import { Button, Loader, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { exitReasonLabel, formatExitDate } from 'src/Components/Inventory/inventoryLabels';
import { PageHeader } from 'src/Components/Navigation/PageHeader';
import { useFetchInventoryExited } from 'src/Hooks/Queries/useFetchInventory';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import styles from './InventoryExitedPage.module.scss';

/** Broken, given, sold… objects: out of the totals and the insurer file, never lost. */
const InventoryExitedPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const assetId = useCurrentAssetId();
  const { data: items, isLoading } = useFetchInventoryExited();
  const listPath = `/asset/${assetId}/inventories`;

  return (
    <div className={styles.container}>
      <Link to={listPath}>
        <Button variant="transparent" leftSection={<IconArrowLeft size={18} />}>
          {t('inventory.back', "Retour à l'inventaire")}
        </Button>
      </Link>
      <PageHeader label={t('inventory.exited.title', 'Objets sortis')} />
      <Text className={styles.sub}>
        {t(
          'inventory.exited.text',
          'Ils ne comptent plus dans l’inventaire ni dans le dossier pour l’assurance. Leurs photos, factures et souvenirs restent.'
        )}
      </Text>
      {isLoading && <Loader />}
      {items?.length === 0 && (
        <Text className={styles.sub}>{t('inventory.exited.empty', 'Aucun objet sorti.')}</Text>
      )}
      {items?.map(item => (
        <button
          key={item.id}
          type="button"
          className={styles.item}
          onClick={() => navigate(`${listPath}/${item.id}`)}
        >
          {item.photos[0] ? (
            <img
              className={styles.thumb}
              src={item.photos[0].previewThumbnailUrl ?? item.photos[0].url}
              alt=""
            />
          ) : (
            <span className={styles.thumb} />
          )}
          <span className={styles.itemText}>
            <span className={styles.itemName}>{item.name}</span>
            <span className={styles.sub}>
              {[
                item.exitReason ? exitReasonLabel(t, item.exitReason) : null,
                item.exitDate ? formatExitDate(item.exitDate) : null,
                item.room?.name,
              ]
                .filter(Boolean)
                .join(' · ')}
            </span>
          </span>
        </button>
      ))}
    </div>
  );
};

export default InventoryExitedPage;
